import Enseignes from './Enseignes';

export default Enseignes;
